var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "omni-theme-box",
    style: _vm.boxStyle,
    on: {
      "click": _vm.onClick
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }